import {AddSchema} from "mobx-graphlink";
import {GetValues_ForSchema} from "js-vextensions";
import {TriggerSet} from "../@TriggerSet.js";
import {EffectPointer} from "../../@Shared/EffectPointer.js";

export class EngineConfig_ConceptLink {
	constructor(initialData: Partial<EngineConfig_ConceptLink>) { Object.assign(this, initialData); }

	enabled: boolean;

	// triggers
	nextSequence_triggerSet: TriggerSet;
	prevSequence_triggerSet: TriggerSet;
	playAudio_triggerSet: TriggerSet;
	randomizeAudio_triggerSet: TriggerSet;

	voiceSoundTag: string;
	volumeMultiplier: number;

	// dream event-sequence selection+effects
	lucidSegmentsOnly: boolean;
	segmentMinEvents: number;
	eventMaxWords: number;
	sequenceSize: number;
	recencyBoosts: {[key: string]: number};
	cueRC_chance: number;
	cueRC_chanceAsBuildup: boolean;

	// audio files
	soundFolder: string;
	soundVolume: number;
	soundDurationLimit: number;
	effect2: EffectPointer;
	effect2_delay: number;
	effect2_chance: number;
	effect2_chanceAsBuildup: boolean;

	// solver
	solver_enabled: boolean;
	solver_minSequences: number;
	solver_requireAudioPlay: boolean;
	solver_markProgressBeforeCompletion: boolean;
	solver_maxTimeForProgress: number; // in seconds
}
AddSchema("EngineConfig_ConceptLink", {
	properties: {
		enabled: {type: "boolean"},

		nextSequence_triggerSet: {$ref: "TriggerSet"},
		prevSequence_triggerSet: {$ref: "TriggerSet"},
		playAudio_triggerSet: {$ref: "TriggerSet"},
		randomizeAudio_triggerSet: {$ref: "TriggerSet"},
		signalRC_triggerSet: {$ref: "TriggerSet"},

		voiceSoundTag: {type: "string"},
		volumeMultiplier: {type: "number"},

		lucidSegmentsOnly: {type: "boolean"},
		segmentMinEvents: {type: "number"},
		eventMaxWords: {type: "number"},
		sequenceSize: {type: "number"},
		recencyBoosts: {patternProperties: {"[0-9]+": {type: "number"}}},
		cueRC_chance: {type: "number"},
		cueRC_chanceAsBuildup: {type: "boolean"},

		soundFolder: {type: "string"},
		soundVolume: {type: "number"},
		soundDurationLimit: {type: "number"},
		effect2: {type: "object"},
		effect2_delay: {type: "number"},
		effect2_chance: {type: "number"},
		effect2_chanceAsBuildup: {type: "boolean"},

		solver_enabled: {type: "boolean"},
		solver_minSequences: {type: "number"},
		solver_requireAudioPlay: {type: "boolean"},
		solver_markProgressBeforeCompletion: {type: "boolean"},
		solver_maxTimeForProgress: {type: "number"},
	},
});